import PropTypes from 'prop-types';
import { TableCell } from '@mui/material';

const DcTableCell = ({hasAC, hasDC, data, header}) => {
  if (hasDC) {
    return <TableCell align="right" sx={{fontWeight: header ? 'bold' : 'normal'}}>{data}</TableCell>
  }
  return null;
}

export default DcTableCell;

DcTableCell.propTypes = {
  hasAC: PropTypes.bool,
  hasDC: PropTypes.bool, 
  data: PropTypes.any,
  header: PropTypes.bool,
}